export default {
  inject: ['load'],
  data() {
    return {
      allBloodCirculationsForOther: [],
      bloodCirculation: null,
    };
  },
  methods: {
    getListOfBloodCirculationsForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllBloodCirculations').then(() => {
        if (this.$store.state.bloodCirculationModule.successFlag) {
          this.allBloodCirculationsForOther =
            this.$store.state.bloodCirculationModule.allBloodCirculations;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.bloodCirculationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfBloodCirculationsForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getBloodCirculationFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getBloodCirculation', id).then(() => {
        if (this.$store.state.bloodCirculationModule.successFlag) {
          this.bloodCirculation = this.$store.state.bloodCirculationModule.bloodCirculation;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.bloodCirculationModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getBloodCirculationFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.bloodCirculationModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
